import type { Asset } from 'contentful';
import type { SerializableRecord } from '../model';

export type ContentfulFile = Asset['fields']['file'];

export function transformContentfulFile(
  file: ContentfulFile
): SerializableRecord {
  const details = file.details;
  const image = details.image;

  return {
    url: file.url,
    contentType: file.contentType,
    details: details
      ? {
          image: image
            ? {
                width: image.width,
                height: image.height
              }
            : undefined
        }
      : undefined
  };
}
